import { parseSEKToOre } from '@budgie/shared';

/**
 * HTML `pattern` for free-text decimal inputs (`type="text" inputMode="decimal"`).
 * Accepts digits with optional spaces as thousand separators and up to two decimals
 * after a comma or dot, e.g. "1 250,50". Empty is allowed (treated as 0).
 */
export const DECIMAL_INPUT_PATTERN = '\\s*[0-9][0-9\\s]*([.,][0-9]{0,2})?\\s*';

const DECIMAL_INPUT_REGEX = new RegExp(`^(?:${DECIMAL_INPUT_PATTERN})?$`);

/** Format öre as an editable kr value with comma decimal ("1250,5") that round-trips via parseSEKToOre. */
export function oreToInputValue(ore: number): string {
  return String(ore / 100).replace('.', ',');
}

/**
 * Parse a kr input to öre. Empty input → 0. Returns null for anything that isn't a
 * non-negative number with at most two decimals (parseSEKToOre alone would return 0).
 */
export function parseMoneyInput(value: string): number | null {
  if (value.trim() === '') return 0;
  if (!DECIMAL_INPUT_REGEX.test(value)) return null;
  return parseSEKToOre(value);
}
